import { redirectSchema } from "@/router/dtos";
import type { RouteRecordRaw } from "vue-router";
import SignupPage from "./SignupPage.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/signup",
    name: "signup",
    component: SignupPage,
    props: (route) => ({
      redirect: redirectSchema.parse(route.query),
    }),
  },
];

export default routes;
